export enum UserDocumentStatus {
    VERIFIED = 'VERIFIED',
    PENDING = 'PENDING',
    REJECTED = 'REJECTED',
    WAITING = 'WAITING',
}

export interface SendDocumentDto {
    documentNumber: string;
    documentType: string;
    fileBase64: string;
    fileName: string;
}

export interface CreateUser {
    name: string,
    login: string,
    email: string,
    password: string
    confirm: string
}

export type UserRole = 'Admin' | 'Client' | 'Manager' | 'Super Admin' | 'Supplier' ;

export interface UserInfoLogin {
  id: number;
  name: string;
  email: string;
  login: string;
  password: string;
  role: UserRole;
  createdAt: string;
  updatedAt: string;
}

export interface CreateUserDto {
  email: string;
  name: string;
  login: string;
  fee?: string;
  password?: string;
  role: string;
  organizationId?: number;
}